import { BinIcon } from '@/components/SvgIcons/BinIcon';
import { SingleIconButton } from '../../Button/SingleIconButton';
import { DownloadIcon } from '@/components/SvgIcons/DownloadIcon';
import { SolidPlusIcon } from '@/components/SvgIcons/SolidPlusIcon';
import { Switch } from '@/components/Controls/Switch';
import { twMerge } from 'tailwind-merge';

interface TableHeaderActionsProps {
  colSpan: number;
  text: string;
  disableDeactivate?: boolean;
  disableDownload?: boolean;
  switchActive?: boolean;
  onDeactivate?: () => void;
  onDownload?: () => void;
  onCreate?: () => void;
  onSwitchChange?: () => void;
}

export const TableHeaderActions = ({
  colSpan = 8,
  text,
  disableDeactivate,
  disableDownload,
  switchActive,
  onDeactivate,
  onDownload,
  onCreate,
  onSwitchChange,
}: TableHeaderActionsProps) => {
  return (
    <tr>
      <td
        colSpan={colSpan - 3}
        className="sticky left-0 bg-purple-5433FF !border-0 dark-mode:bg-purple-5433FF/60"
      >
        <div className="pl-[52px] flex items-center gap-10">
          <div className="text-white text-2sm dark-mode:text-gray-900">
            {text}
          </div>
          <div className="flex items-center gap-5">
            {onDeactivate && (
              <SingleIconButton
                icon={BinIcon}
                iconClassName="[&>path]:fill-white"
                disabled={disableDeactivate}
                onClick={onDeactivate}
              />
            )}
            {onDownload && (
              <SingleIconButton
                icon={DownloadIcon}
                iconClassName="w-[18px] h-[18px] [&>path]:fill-white"
                disabled={disableDownload}
                onClick={onDownload}
              />
            )}
            {onSwitchChange && (
              <Switch
                switchClassName={twMerge(
                  '!w-[22px] !h-[12px] !bg-white before:!w-[10px] before:!h-[10px] before:!bg-primary before:!left-[1.5px]',
                  switchActive && 'before:!left-[92%]',
                )}
                checked={switchActive}
                onChange={onSwitchChange}
              />
            )}
            {onCreate && (
              <SingleIconButton
                icon={SolidPlusIcon}
                iconClassName="w-[18px] h-[18px] [&>mask>path:first-child]:stroke-white [&>mask>path:first-child]:fill-white [&>g>path]:fill-white"
                onClick={onCreate}
              />
            )}
          </div>
        </div>
      </td>
      <td className="!border-0 !p-0 bg-purple-5433FF" />
      <td className="!border-0 !p-0 bg-purple-5433FF" />
      <td className="!border-0 !p-0 bg-purple-5433FF" />
    </tr>
  );
};
